import React from 'react';
import MypageScheduleFailContainer from 'containers/MypageScheduleFailContainer/MypageScheduleFailContainer';

export default function MypageScheduleFailPage() {
    return (
        <MypageScheduleFailContainer />
    )
}
